export class ContainerRegistryRoutes
{
    static Home: string = "/";

    // container registry
    static ContainerRegistryList: string = "/container-registry/list";
    static ContainerRegistryNew: string = "/container-registry/new";
    static ContainerRegistryView(id: string)
    {
        return `/container-registry/${id}/view`;
    }
    static ContainerRegistryEdit(id: string)
    {
        return `/container-registry/${id}/edit`;
    }
    static ContainerRegistryCopy(id: string)
    {
        return `/container-registry/${id}/copy`;
    }
}